import { render, staticRenderFns } from "./home_city_station.vue?vue&type=template&id=70df51c7&scoped=true"
import script from "./home_city_station.vue?vue&type=script&lang=js"
export * from "./home_city_station.vue?vue&type=script&lang=js"
import style0 from "./home_city_station.vue?vue&type=style&index=0&id=70df51c7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df51c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70df51c7')) {
      api.createRecord('70df51c7', component.options)
    } else {
      api.reload('70df51c7', component.options)
    }
    module.hot.accept("./home_city_station.vue?vue&type=template&id=70df51c7&scoped=true", function () {
      api.rerender('70df51c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_city_station.vue"
export default component.exports